import * as _ from 'underscore';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Comment from '@material-ui/icons/Comment';
import * as Utils from '../../../lib/designerUtils';
import Console from '../../../lib/debug';
import { redzoneTypes, workoutParamTypes } from '../../../lib/paramTypes';

export class ExerciseClass extends Component {
    state = { displayNotes: false };

    getSummaryLeaderBoardTag = () => {
        if (!this.props.exerciseSummary) {
            return null;
        }

        let isRedzone =
            this.props.exerciseSummary.redzone_value &&
            this.props.exerciseSummary.redzone_value !== '';

        if (!isRedzone) {
            return null;
        }
        return (
            <span className="leaderboard-tag-value">
                ({this.props.exerciseSummary.redzone_value})
            </span>
        );
    };

    getLeaderboardText = type => {
        if (!type) {
            return '';
        }
        let redzoneType = _.find(redzoneTypes, { id: parseInt(type, 10) });
        return `FOR ${redzoneType.title}`.toUpperCase();
    };

    getLeaderboardTag = () => {
        let isRedzone = this.props.block && this.props.block.redzone_type;
        if (!isRedzone) {
            return null;
        }
        let leaderboardText = this.getLeaderboardText(
            this.props.block.redzone_type
        );
        if (!leaderboardText) {
            return null;
        }
        return (
            <div className="leaderboard-tag">
                <i className="mdi mdi-trophy" />
                {leaderboardText}
                {this.getSummaryLeaderBoardTag()}
            </div>
        );
    };

    toggleNotesVisibility(e) {
        e.preventDefault();
        this.setState(() => ({
            displayNotes: !this.state.displayNotes
        }));
    }
    render() {
        Console.render('Exercise');
        const {
            exercise,
            session,
            block,
            position,
            isLast,
            isPreview,
            calendarInstructionsEnabled,
            sessionSummary,
            exerciseSummary
        } = this.props;

        let instruction,
            redzone,
            typeSearch = null;
        let noLine = true;
        let testedFlag = false;
        if (exercise && exercise.abr) {
            let abr = Utils.calculateAbrToSave(exercise);
            exercise.abr = abr;
        }

        if (block.exerciseKeys) {
            noLine =
                block.exerciseKeys.length === 1 ||
                block.exerciseKeys.length === 0 ||
                isLast;
            if (noLine === undefined) {
                noLine = true;
            }
        } else {
            noLine = block.workoutSetExercises.length === 1 || isLast;
        }
        let exerciseClasses = `item-section-exercise ${
            noLine ? 'no-line' : ''
        }`;

        let hasSummary = false;
        let completed = null;
        let logged = sessionSummary && sessionSummary.logged == 1;
        let summaryInfo = null;
        let outstandingDetail = null;
        let testedTag = null;
        if (exerciseSummary) {
            testedFlag = exerciseSummary.resets_working_max === 1;
            completed = exerciseSummary.completed === 1;
            hasSummary = true;
            let progressWM = null;
            if (exerciseSummary.is_wm && exerciseSummary.is_up === 1) {
                progressWM = (
                    <div className="orange-detail">
                        <span>
                            <i className="mdi mdi-arrow-up" />WM{' '}
                        </span>{' '}
                    </div>
                );
            } else if (exerciseSummary.is_wm && exerciseSummary.is_up === 0) {
                progressWM = (
                    <div className="orange-detail">
                        <span>
                            <i className="mdi mdi-arrow-down" />WM
                        </span>
                    </div>
                );
            }
            let personalRecord = exerciseSummary.is_pr ? (
                <div className="icon-detail">
                    <span>
                        <i className="mdi mdi-star" />PR
                    </span>
                </div>
            ) : null;
            outstandingDetail = (
                <div className="extra-detail">
                    {progressWM}
                    {personalRecord}
                </div>
            );
            if (testedFlag) {
                testedTag = (
                    <div className="tag">
                        <i className="mdi mdi-check" />TESTED
                    </div>
                );
            }
        }

        let exerciseCount = 0;
        if (block.exerciseKeys) {
            exerciseCount = block.exerciseKeys.length;
        } else {
            exerciseCount = block.workoutSetExercises.length;
        }

        if (
            calendarInstructionsEnabled &&
            exercise &&
            exercise.instruction.length > 0
        ) {
            instruction = !/^\s+$/g.test(exercise.instruction) ? (
                <pre className="description-toggle">{exercise.instruction}</pre>
            ) : null;
        }

        let blockIndex = 0;
        if (session.setKeys && session.setKeys.length > 0) {
            typeSearch = typeof session.setKeys[0];
        }
        if (session.setKeys && typeSearch === 'number') {
            if (
                typeof block.key === 'string' &&
                block.key.indexOf('k::') >= 0
            ) {
                blockIndex = session.setKeys.indexOf(block.key);
            } else {
                blockIndex = session.setKeys.indexOf(parseInt(block.key, 10));
            }
        } else if (session.setKeys && typeSearch !== 'number') {
            blockIndex = session.setKeys.indexOf(block.key);
        } else if (!session.setKeys) {
            blockIndex = _.findIndex(session.workoutSets, { id: block.id });
        }

        let subtitle = Utils.getBlockTitle(blockIndex) + position;
        subtitle =
            exerciseCount > 1 ? subtitle : Utils.getBlockTitle(blockIndex);

        let subtitleClass = 'alphabet-icon';

        let prescriptionClass = 'prescription';

        let wasCompletedAsPrescribed = true;
        let wasCompleted = false;

        if (hasSummary && logged) {
            let summaryObject = _.filter(exerciseSummary, function(obj) {
                return obj && (obj.prescribed || obj.actual);
            });

            if (summaryObject.length === 0) {
                wasCompleted = exerciseSummary.completed === 1;
                wasCompletedAsPrescribed = !exerciseSummary.diff;
            }

            if (summaryObject.length) {
                for (var i = 0; i < summaryObject.length; i++) {
                    let set = summaryObject[i];

                    if (set.actual) {
                        wasCompleted = true;
                    }

                    if (set.actual === 'MAX') {
                        if (parseInt(set.prescribed, 10) === 0) {
                            wasCompletedAsPrescribed = false;
                        }
                    } else {
                        if (set.prescribed !== 0 && set.diff !== 0) {
                            wasCompletedAsPrescribed = false;
                        }
                    }
                }
            }

            let paramTypes = [exercise.param_1_type, exercise.param_2_type];
            let isLWP = paramTypes.includes(workoutParamTypes.LINEAR);
            if (exercise.abr !== exerciseSummary.abr && !isLWP) {
                summaryInfo = (
                    <div className="prescription summary-prescription">
                        {exerciseSummary.abr}
                    </div>
                );
            }
        }

        if (wasCompleted && wasCompletedAsPrescribed) {
            subtitleClass += ' fill-color-green';
        } else if (wasCompleted && !wasCompletedAsPrescribed) {
            subtitleClass += ' fill-color-yellow';
            prescriptionClass += ' strike';
        }

        let exerciseRender = null;
        let exerciseNotes = null;
        if (exercise && exerciseCount >= 1) {
            const exerciseRef = _.find(this.props.exerciseRef, {
                exercise_id: exercise.exercise_id
            });

            const templateExercise =
                exerciseRef && exerciseRef.hasOwnProperty('title')
                    ? exerciseRef
                    : exercise;

            const templateExerciseTitle = templateExercise.title;
            const titleFromExerciseSummary = exerciseSummary
                ? exerciseSummary.title
                : null;

            const titleToDisplay = titleFromExerciseSummary
                ? titleFromExerciseSummary
                : templateExerciseTitle;

            const wasExerciseSwapped = exerciseSummary
                ? templateExercise.exercise_id !== exerciseSummary.exercise_id
                : false;

            const prescribedTitleToDisplay = wasExerciseSwapped ? (
                <div className="prescription strike">
                    {templateExerciseTitle}
                </div>
            ) : (
                <div>{titleToDisplay}</div>
            );

            const prescribedTitle = (
                <strong className="title">{prescribedTitleToDisplay}</strong>
            );

            const performedTitle = (
                <strong className="title">
                    {wasExerciseSwapped && <div>{titleToDisplay}</div>}
                </strong>
            );

            if (
                wasExerciseSwapped &&
                wasCompleted &&
                wasCompletedAsPrescribed
            ) {
                subtitleClass += ' fill-color-yellow';
            }

            if (
                exercise.abr &&
                exercise.abr.toLowerCase().indexOf('undefined') >= 0
            ) {
                exercise.abr = '';
            }
            if (
                exercise.abr2 &&
                exercise.abr2.toLowerCase().indexOf('undefined') >= 0
            ) {
                exercise.abr2 = '';
            }
            let parseAbr1 = { __html: exercise.abr };
            let parseAbr2 = { __html: exercise.abr2 };
            let abrHTML = <div dangerouslySetInnerHTML={parseAbr1} />;
            let abr2HTML = <div dangerouslySetInnerHTML={parseAbr2} />;
            let exerciseInfo = null;

            if (templateExerciseTitle) {
                exerciseInfo = (
                    <div className="exercise-title-info">
                        {prescribedTitle}
                        <span className={prescriptionClass}>
                            {' '}
                            {abrHTML} {abr2HTML}
                        </span>{' '}
                        {performedTitle}
                        {summaryInfo} {redzone}
                    </div>
                );
            }

            let leaderboardTag = null;
            let leaderboardTagVisible = noLine && isLast;
            if (leaderboardTagVisible) {
                leaderboardTag = this.getLeaderboardTag();
            }

            if (exerciseSummary) {
                if (exerciseSummary.redzone_value) {
                    redzone = (
                        <span className="redzone-value-summary">
                            {' '}
                            ({exerciseSummary.redzone_value}){' '}
                        </span>
                    );
                }
            }

            if (exerciseSummary && exerciseSummary.notes !== null) {
                exerciseNotes = (
                    <div className="exercise-notes">
                        <span className="icon">
                            <img
                                alt="comment"
                                src="https://static.trainheroic.com/images/ExerciseCommentIcon.png"
                            />
                        </span>
                        <span className="notes">{exerciseSummary.notes}</span>
                    </div>
                );
            }

            exerciseRender = (
                <li className={exerciseClasses}>
                    <div className="default-view">
                        <div className="exercise-title">
                            <span className={subtitleClass}>{subtitle}</span>
                            {exerciseInfo}
                        </div>
                        {testedTag}
                        {leaderboardTag}
                        {outstandingDetail}
                        {exerciseNotes}
                        {instruction}
                    </div>

                    <div className="summary-view layout-column">
                        <div className="exercise-title">
                            <span className={subtitleClass}>{subtitle}</span>
                            <div className="exercise-title-info">
                                {prescribedTitle}
                                <span className={prescriptionClass}>
                                    {' '}
                                    {abrHTML} {abr2HTML}
                                </span>{' '}
                                {performedTitle}
                                {summaryInfo} {redzone}
                            </div>
                        </div>
                        {testedTag}
                        {leaderboardTag}
                        {outstandingDetail}
                        {exerciseNotes}
                        {instruction}
                    </div>
                </li>
            );
        } else {
            let title = <strong className="title">{block.title}</strong>;
            if (!isPreview) {
                title = (
                    <strong className="title">
                        <span>{block.title}</span>
                    </strong>
                );
            }

            exerciseRender = (
                <li className={exerciseClasses}>
                    <div className="exercise-title">
                        <div className="default-view">
                            <span className={subtitleClass}>{subtitle}</span>
                            <div className="exercise-title-info">{title}</div>
                        </div>
                        <div className="summary-view">
                            <span className={subtitleClass}>{subtitle}</span>
                            <div className="exercise-title-info">{title}</div>
                        </div>
                    </div>
                    {instruction}
                </li>
            );
        }

        return exerciseRender;
    }
}

const mapStateToProps = (state, ownProps) => {
    let exercise = state.calendar.exerciseTree[ownProps.exerciseKey];
    let exerciseKey = ownProps.exerciseKey;
    let workoutId = ownProps.session.workout_id;

    if (ownProps.item) {
        // This is used for the <Preview /> component
        exercise = ownProps.item;
        exerciseKey = exercise.id;
    }

    return {
        ...ownProps,
        exercise,
        exerciseSummary: state.summary.calendarSummaryExerciseTree[exerciseKey],
        sessionSummary: state.summary.calendarSummarySessionTree[workoutId],
        exerciseRef: state.library.exerciseRef
    };
};

export default connect(mapStateToProps)(ExerciseClass);



// WEBPACK FOOTER //
// ./src/view/calendar/components/Exercise.jsx